/**
 * A compact row of clickable merge-field chips. Clicking one inserts its
 * {{token}} via the supplied onInsert callback (the caller splices it into the
 * focused field at the cursor). Shared by the template editor and the composer
 * so recruiters insert valid fields instead of typing — and mistyping — them.
 */
import { MERGE_FIELDS } from '../mergeFields';

export default function MergeFieldChips({
  onInsert,
  className = '',
}: {
  onInsert: (token: string) => void;
  className?: string;
}) {
  return (
    <div className={`flex flex-wrap items-center gap-1 ${className}`}>
      <span className="text-[11px] text-gray-400">Insert field:</span>
      {MERGE_FIELDS.map((f) => (
        <button
          key={f.token}
          type="button"
          onClick={() => onInsert(`{{${f.token}}}`)}
          title={`Insert {{${f.token}}}`}
          className="rounded-full border border-gray-300 px-2 py-0.5 text-[11px] font-medium text-gray-600 transition-colors duration-150 hover:border-primary-400 hover:text-primary-700 dark:border-gray-600 dark:text-gray-300 dark:hover:border-primary-500 dark:hover:text-primary-300"
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}
